// extracted by mini-css-extract-plugin
export default {"main_container":"MainLayout_main_container__H2hxM","logo":"MainLayout_logo__c1zzK"};